import { ReactComponent as CalendarIcon } from "../../../assets/icons/calendar_today.svg";

const HolidaysHeader = () => {
    return (
        <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center">
                <h2 
                    className="txt-main fw-bold m-0" 
                    style={{ fontSize: "var(--text-h3)", cursor: "pointer" }}
                >
                    Holidays
                </h2>
                
                <CalendarIcon 
                    style={{ 
                        width: "36px", 
                        height: "36px", 
                        color: "var(--brand-primary)", 
                        fill: "currentColor" 
                    }} 
                />
            </div>

            <div 
                className="mt-3 w-100" 
                style={{ 
                    height: "1px", 
                    backgroundColor: "var(--gray-200)" 
                }} 
            />
        </div>
    );
};

export default HolidaysHeader;